import { useTranslation } from "react-i18next";
import { OrganizationRoleType } from "../../../../autogen/bff-api";
import { UserRole } from "./types";
import { useSelectableRoles } from "./useSelectableRoles";

export const useRoles = (): UserRole[] => {
  const { t } = useTranslation();
  const selectableRoles = useSelectableRoles();

  return [
    ...selectableRoles,
    {
      value: OrganizationRoleType.Owner,
      label: t("Owner"),
    },
  ];
};
